// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1407b060","547":"10db357f","625":"fffce83b","789":"3c0e6ba5"}[chunkId] + ".chunk.js";
};